/* Biome flip-dropdown — progressive enhancement that replaces a native <select>
   (wrapped in <div class="flipdd" data-flipdd>) with the prototype's custom dropdown
   (FlipDropdown in hero.jsx): a styled trigger button + a listbox that flips up or
   down based on viewport room. The native <select> stays in the DOM (hidden) as the
   value holder + change source, so the owning section's JS keeps working as-is.

   - User picks an option  → sets the <select> value + fires a native 'change' (so the
     section's existing change listener runs).
   - Section snaps the value programmatically → it sets <select>.value then dispatches a
     'flipdd:sync' event so the trigger label updates (without re-firing 'change', which
     would loop the section's own listener). */
(function () {
  function enhance(dd) {
    if (dd.__flipdd) return;
    var sel = dd.querySelector('select');
    if (!sel) return;
    dd.__flipdd = true;
    sel.style.display = 'none';

    var opts = Array.prototype.slice.call(sel.options);
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = sel.className || 'pln__freq-sel';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    if (sel.getAttribute('aria-label')) trigger.setAttribute('aria-label', sel.getAttribute('aria-label'));

    var menu = document.createElement('ul');
    menu.className = 'flipdd__menu';
    menu.setAttribute('role', 'listbox');
    opts.forEach(function (o) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'option');
      b.className = 'flipdd__item';
      b.textContent = o.textContent;
      b.setAttribute('data-val', o.value);
      b.addEventListener('click', function (e) { e.stopPropagation(); choose(o.value); close(); });
      li.appendChild(b);
      menu.appendChild(li);
    });
    dd.appendChild(trigger);
    dd.appendChild(menu);

    function syncLabel() {
      var cur = sel.options[sel.selectedIndex];
      trigger.textContent = cur ? cur.textContent : '';
      var items = menu.querySelectorAll('.flipdd__item');
      for (var i = 0; i < items.length; i++) {
        var on = items[i].getAttribute('data-val') === sel.value;
        items[i].classList.toggle('flipdd__item--on', on);
        items[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }
    function flip() {
      var r = trigger.getBoundingClientRect();
      var menuH = Math.min(280, opts.length * 36 + 12);
      var below = window.innerHeight - r.bottom, above = r.top;
      dd.classList.remove('flipdd--up', 'flipdd--down');
      dd.classList.add((below >= menuH + 12) ? 'flipdd--down' : (above >= menuH + 12 ? 'flipdd--up' : (below >= above ? 'flipdd--down' : 'flipdd--up')));
    }
    function open() { flip(); dd.classList.add('flipdd--open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { dd.classList.remove('flipdd--open'); trigger.setAttribute('aria-expanded', 'false'); }
    function choose(v) {
      if (sel.value !== String(v)) { sel.value = String(v); sel.dispatchEvent(new Event('change', { bubbles: true })); }
      syncLabel();
    }

    trigger.addEventListener('click', function (e) { e.stopPropagation(); dd.classList.contains('flipdd--open') ? close() : open(); });
    sel.addEventListener('change', syncLabel);
    sel.addEventListener('flipdd:sync', syncLabel);
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (dd.classList.contains('flipdd--open')) flip(); });
    syncLabel();
  }
  function boot() { document.querySelectorAll('[data-flipdd]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
